import { useState, useEffect } from 'react';
import { Input, Label } from '../../../../../styles/component.styles.jsx';

const SubtitleSection = ({ initialContent = {}, initialMetadata = {}, onChange }) => {
  const [text, setText] = useState(initialContent?.text || '');

  useEffect(() => {
    onChange({ content: { text }, metadata: {} });
  }, [text]);

  return (
    <>
      <Label>Subtitle Text</Label>
      <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Enter subtitle..." />
    </>
  );
};

export default SubtitleSection;